import {Pipe, PipeTransform} from '@angular/core';
import {CommunicationTypesEnum} from '../../Shared/Enum/communication-types.enum';

@Pipe({
  name: 'communicationIcon',
  standalone: false
})
export class CommunicationIconPipe implements PipeTransform {

  transform(typeId: number): string {

    if (!typeId) {
      return 'chats-teardrop';
    }

    switch (typeId) {
      case CommunicationTypesEnum.events:
        return 'confetti';

      case CommunicationTypesEnum.meetings:
        return 'users-three';

      case CommunicationTypesEnum.warnings:
        return 'megaphone';

      case CommunicationTypesEnum.breakdowns:
        return 'wrench';

      case CommunicationTypesEnum.chats:
        return 'chat-circle';

      case CommunicationTypesEnum.lists:
        return 'list-bullets';

      default:
        return 'chats-teardrop';
    }

  }

}
